import React from "react";
import Wordmark from "./Wordmark";

export default function Footer() {
  return (
    <footer
      className="border-t mt-32"
      style={{ borderColor: "var(--mek-border)" }}
      data-testid="main-footer"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-3 gap-8">
        <div>
          <Wordmark variant="color" size="md" />
          <p className="text-prose text-sm mt-5 max-w-xs">
            A Manage(Meant) Excellence product. Practical, human-centered support for the moments management asks more of you than anyone prepared you for.
          </p>
        </div>
        <div className="text-sm">
          <p className="eyebrow mb-4">For managers</p>
          <ul className="space-y-2 text-prose">
            <li><a href="#scenarios" className="hover:text-[color:var(--mme-teal)]">All scenarios</a></li>
            <li><a href="#how" className="hover:text-[color:var(--mme-teal)]">How it works</a></li>
            <li><a href="#faq" className="hover:text-[color:var(--mme-teal)]">FAQ</a></li>
          </ul>
        </div>
        <div className="text-sm">
          <p className="eyebrow mb-4">A friendly note</p>
          <p className="text-prose">
            This kit is not a substitute for HR, legal counsel, or mental health care. When in doubt, escalate. Some situations deserve additional support, guidance, or expertise.
          </p>
          <p className="text-prose mt-4">
            Questions or feedback?{" "}
            <a
              href="mailto:hello@managemeantexcellence.com"
              className="underline hover:no-underline"
              style={{ color: "var(--mme-teal)" }}
              data-testid="footer-contact-email"
            >
              hello@managemeantexcellence.com
            </a>
          </p>
        </div>
      </div>
      <div className="border-t" style={{ borderColor: "var(--mek-border)" }}>
        <div className="max-w-6xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-[color:var(--mek-text-3)]">
          <span>© {new Date().getFullYear()} Manage(Meant) Excellence</span>
          <a
            href="https://www.managemeantexcellence.com"
            target="_blank"
            rel="noopener"
            className="hover:text-[color:var(--mme-teal)] transition-colors"
            data-testid="footer-back-to-site"
          >
            ← Back to managemeantexcellence.com
          </a>
        </div>
      </div>
    </footer>
  );
}

